import { render, staticRenderFns } from "./backUserPriceAudit.vue?vue&type=template&id=18e9b1d8&scoped=true&"
import script from "./backUserPriceAudit.vue?vue&type=script&lang=js&"
export * from "./backUserPriceAudit.vue?vue&type=script&lang=js&"
import style0 from "./backUserPriceAudit.vue?vue&type=style&index=0&id=18e9b1d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9b1d8",
  null
  
)

export default component.exports